import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CompetenciesModal from './modals/CompetenciesModal';
import CareerDevelopmentModal from './modals/CareerDevelopmentModal';
import HRAspectsModal from './modals/HRAspectsModal';
import RecommendationModal from './modals/RecommendationModal';
import TrainingModal from './modals/TrainingModal';
import Swal from 'sweetalert2';

const CategoryTab = () => {
  const navigate = useNavigate();
  const [activePopup, setActivePopup] = useState(null);
  const [isValidJobLevel, setIsValidJobLevel] = useState(true);

  const closePopup = () => setActivePopup(null);

  const checkJobLevel = () => {
    const jobLevel = localStorage.getItem('JobLevel');
    if (['03', '04', '04A', '04B', '02A', '02', '01A', '01'].includes(jobLevel)) {
      setIsValidJobLevel(true);
    } else {
      setIsValidJobLevel(false);
    }
  };

  const checkPeriodAndYear = () => {
    const period = localStorage.getItem('period');
    const year = localStorage.getItem('year');
    if (!period || !year) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Please select the Period and Year.',
        confirmButtonColor: '#3085d6',
      });
      return false;
    }
    return true;
  };

  useEffect(() => {
    checkJobLevel();
  }, []);

  const categories = [
    { id: 'KPI', label: 'KPI', color: 'bg-orange-300' },
    { id: 'Competencies', label: 'Competencies', color: 'bg-green-300' },
    { id: 'CareerDevelopment', label: 'Career Development', color: 'bg-blue-300' },
    { id: 'HRAspects', label: 'HR Aspects', color: 'bg-pink-300' },
    { id: 'Recommendation', label: 'Recommendation', color: 'bg-purple-400' },
    { id: 'Training', label: 'TNI', color: 'bg-teal-400' },
  ];

  const modalComponents = {
    Competencies: CompetenciesModal,
    CareerDevelopment: CareerDevelopmentModal,
    HRAspects: HRAspectsModal,
    Recommendation: RecommendationModal,
    Training: TrainingModal,
  };

  const alwaysAccessibleCategories = ['Competencies', 'CareerDevelopment', 'HRAspects', 'Training', 'KPI'];

  return (
    <div className="w-full px-4 py-2">
      {/* Button Tabs */}
      <div className="flex flex-wrap gap-2 mb-4">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`${category.color} px-4 py-2 rounded text-sm sm:text-base flex-grow sm:flex-grow-0 transition-all hover:opacity-80 ${!isValidJobLevel && !alwaysAccessibleCategories.includes(category.id) ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            onClick={() => {
              if (isValidJobLevel || alwaysAccessibleCategories.includes(category.id)) {
                if (category.id === 'KPI') {
                  navigate('/kpi-entry');
                  return;
                }
                if (category.id === 'Competencies' && !checkPeriodAndYear()) {
                  return;
                }
                setActivePopup(category.id);
              }
            }}
            disabled={!isValidJobLevel && !alwaysAccessibleCategories.includes(category.id)}
          >
            {category.label}
          </button>
        ))}
      </div>

      {/* Render Active Modal */}
      {activePopup && modalComponents[activePopup] &&
        React.createElement(modalComponents[activePopup], { closePopup })}
    </div>
  );
};

export default CategoryTab;
